export const zh_CN = {
  activityRules: '活动规则',
  clickToGet: '点击领取',
  alreadyReceived: '您已领取过该礼品了~',
  receiveSuccess: '领取成功',
  immediateUse: '立即使用',
  receiveFailed: '领取失败',
  sorryEmpty: '抱歉您来晚了礼品已经被领光了',
  continueToOrder: '继续下单',
  login: {
    phoneLogin: '手机号登录领取',
    phoneNumber: '输入手机号',
    agree: '同意',
    serviceTerms: '《顺丰同城用户服务协议》',
    and: '和',
    privacyAgreement: '《顺丰同城隐私政策》',
    LogIn: '登 录'
  },
  messages: {
    enterMessageCode: '输入短信验证码',
    enterVoiceCode: '输入语音验证码',
    sendTo: '已发送至',
    willBeSentTo: '将发送至',
    secondsSendAgain: '秒后再次发送',
    sendAgain: '再次发送',
    voiceCode: '已发送语音验证码，请接听0571开头的座机电话',
    know: '我知道了',
    codeBeenSent: '验证码已发送'
  }
};

export const zh_HK = {
  activityRules: '活動規則',
  clickToGet: '點擊領取',
  alreadyReceived: '您已經領取過該禮品喇～',
  receiveSuccess: '領取成功',
  immediateUse: '即時使用',
  receiveFailed: '領取失敗',
  sorryEmpty: '對唔住，您來遲咗，禮品已經俾人領晒喇',
  continueToOrder: '繼續落單',
  login: {
    phoneLogin: '手機號碼登錄領取',
    phoneNumber: '輸入手機號碼',
    agree: '同意',
    serviceTerms: '《順豐同城用戶服務協議》',
    and: '同',
    privacyAgreement: '《順豐同城隱私政策》',
    LogIn: '登 錄'
  },
  messages: {
    enterMessageCode: '輸入短訊驗證碼',
    enterVoiceCode: '輸入語音驗證碼',
    sendTo: '已經發送到',
    willBeSentTo: '將會發送到',
    secondsSendAgain: '秒後再次發送',
    sendAgain: '再次發送',
    voiceCode: '已經發送語音驗證碼，請聽0571開頭嘅固定電話',
    know: '我知喇',
    codeBeenSent: '驗證碼已經發送'
  }
};

export const en = {
  activityRules: 'Activity Rules',
  clickToGet: 'Claim',
  alreadyReceived: 'You’ve already claimed this gift~',
  receiveSuccess: 'Claim Successful',
  immediateUse: 'Use Now',
  receiveFailed: 'Claim Failed',
  sorryEmpty: 'Sorry, all gifts have been claimed!',
  continueToOrder: 'Place your order',
  login: {
    phoneLogin: 'Log in with your phone number to claim the reward',
    phoneNumber: 'Enter Phone Number',
    agree: 'I agree to',
    serviceTerms: '《SoFast User Service Agreement》',
    and: 'and',
    privacyAgreement: '《SoFast Privacy Policy》',
    LogIn: 'Log In'
  },
  messages: {
    enterMessageCode: 'Enter Message Code',
    enterVoiceCode: 'Enter Voice Code',
    sendTo: 'Sent to',
    willBeSentTo: 'Will be sent to',
    secondsSendAgain: 'Seconds to Resend',
    sendAgain: 'Resend',
    voiceCode:
      'Voice code has been sent. Please answer the call from a landline starting with 0571.',
    know: 'Got it',
    codeBeenSent: 'Code has been sent'
  }
};
